import * as React from 'react';

import _ from 'underscore';

import InfoIcon from 'InfoIcon';
import platform from 'Platform';
import ProBadgeIcon from 'ProBadgeIcon';

export default class HelpTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyClicked: this.bodyClicked.bind(this), // Make it possible to remove the body click listener.
      showTooltip: false,
    };
  }

  helpClicked() {
    let showTooltip = !this.state.showTooltip;

    if (showTooltip) {
      let me = this;
      _.delay(() => {
        document.body.addEventListener('click', me.state.bodyClicked);
      });

      if (platform.isIos) {
        document.body.style.cursor = 'pointer'; // This makes any element respond to click events in iOS.
      }
    }

    this.setState({
      showTooltip: showTooltip,
    });
  }

  bodyClicked() {
    if (platform.isIos) {
      document.body.style.cursor = 'default';
    }

    let view = this;

    _.defer(function () {
      document.body.removeEventListener('click', view.state.bodyClicked);
      view.setState({
        showTooltip: false,
      });
    });
  }

  render() {
    let content = [
      <div
        key="helptool-children-div-1"
        className="help-tooltip-button"
        onClick={(e) => {
          this.helpClicked();
        }}
      >
        <InfoIcon className="help-icon" color="#6d9ec4" />
      </div>,
    ];

    let proIcon = '';

    if (this.props.showProIcon) {
      proIcon = (
        <ProBadgeIcon className="pro-badge-icon" color="#f89e1b" size="24" />
      );
    }

    const helpText = {
      className: 'help-text',
    };

    if (this.props.text) {
      helpText.children = this.props.text;
    } else if (this.props.html) {
      helpText.dangerouslySetInnerHTML = { __html: this.props.html };
    }

    if (this.state.showTooltip) {
      content.push(
        <div
          key="helptool-children-div-2"
          className={
            'help-tooltip ' +
            (this.props.above ? 'help-tooltip-above' : 'help-tooltip-below')
          }
        >
          {proIcon}
          {this.props.title && (
            <span className="help-title">{this.props.title}</span>
          )}
          {this.props.children ? this.props.children : <span {...helpText} />}
        </div>,
        <div
          key="helptool-children-div-3"
          className={
            'help-tooltip-arrow ' +
            (this.props.above
              ? 'help-tooltip-arrow-above'
              : 'help-tooltip-arrow-below')
          }
        />
      );
    }

    return (
      <div className={this.props.className + ' help-tooltip-container'}>
        {content}
      </div>
    );
  }
}
